import React from 'react';
import { AccordionContainer } from '../../../../../../../../common/components/accordion/accordion.module';
import { InputLabelContainer } from '../../../../../../../../common/components/form/label/containers/input-label.container';
import { format } from '../../../../../../../../common/services/date.service';
export const LeadBasicInfoComponent = ({ leadDetails, getCategoryName }: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid grid-cols-1 gap-4'>
                        <div><InputLabelContainer label="CategoryName" />
                            <InputLabelContainer label={getCategoryName(leadDetails?.LeadInfo?.category_id)} /></div>
                        <div> <InputLabelContainer
                            label="ProductName"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.LogisticsProductName}
                            /></div>
                        <div> <InputLabelContainer
                            label="VariantName"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.LogisticsVariantName}
                            /></div>
                        <div> <InputLabelContainer
                            label="Name"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.Name}
                            /></div>
                        <div><InputLabelContainer
                            label="Email"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.Email}
                            /></div>
                        <div> <InputLabelContainer
                            label="PhoneNumber"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.PhoneNumber}
                            /></div>
                        <div><InputLabelContainer
                            label="Date"
                        />
                            <InputLabelContainer
                                label={format(leadDetails.LeadInfo?.date)}
                            /></div>
                    </div>
                }
                expandedPanel="userInfo"
                headerTitle="Basic Info"
            />
            <AccordionContainer
                child={
                    <div className='grid grid-cols-1 gap-4'>
                        <div>
                            <InputLabelContainer label="building" />
                            <InputLabelContainer label={leadDetails?.LeadInfo?.start?.location?.address?.building} /></div>
                        <div> <InputLabelContainer
                            label="Locality"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.start?.location?.address?.locality}
                            /></div>
                        <div> <InputLabelContainer
                            label="City"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.start?.location?.address?.city}
                            /></div>
                        <div><InputLabelContainer
                            label="Country"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.start?.location?.address?.country}
                            /></div>
                        <div><InputLabelContainer
                            label="state"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.start?.location?.address?.state}
                            /></div>
                        <div><InputLabelContainer
                            label="Area Code"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.start?.location?.address?.area_code}
                            /></div>
                    </div>
                }
                expandedPanel="fromaddress"
                headerTitle="From address"
            />
            <AccordionContainer
                child={
                    <div className='grid grid-cols-1 gap-4'>
                        <div><InputLabelContainer label="building" />
                            <InputLabelContainer label={leadDetails?.LeadInfo?.end?.location?.address?.building} /></div>
                        <div><InputLabelContainer
                            label="Locality"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.end?.location?.address?.locality}
                            /></div>
                        <div><InputLabelContainer
                            label="City"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.end?.location?.address?.city}
                            /></div>
                        <div><InputLabelContainer
                            label="Country"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.end?.location?.address?.country}
                            /></div>
                        <div><InputLabelContainer
                            label="state"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.end?.location?.address?.state}
                            /></div>
                        <div><InputLabelContainer
                            label="Area Code"
                        />
                            <InputLabelContainer
                                label={leadDetails?.LeadInfo?.end?.location?.address?.area_code}
                            /></div>
                    </div>
                }
                expandedPanel="toaddress"
                headerTitle="To address"
            />
        </>
    )
}
export default LeadBasicInfoComponent;
